import React from 'react';
import { Image } from '@noths/polaris-client-ribbons-design-system';

import type { Product } from '../../../../types/dontgiftguide';
import * as styles from './ExtraSmallProductTile.styles';

export interface ExtraSmallProductTileProps {
  product: Product;
}

export const ExtraSmallProductTile = ({ product }: ExtraSmallProductTileProps) => {
  if (!product) {
    return null;
  }

  return (
    <div css={styles.tile}>
      <a href={product.href}>
        <Image src={product.image.normal} alt="" loading="lazy" />
        <p css={styles.title}>{product.title} »</p>
      </a>
    </div>
  );
};
